
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 21 21","fill":"currentColor","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3.475 2.738a.738.738 0 00-1.475 0v15.524c0 .408.33.738.738.738h15.524a.738.738 0 100-1.475H3.475V2.738z"}}),_c('path',{attrs:{"d":"M14.651 5.143a.676.676 0 00-.544-.13.714.714 0 00-.466.33l-4.145 6.683L7.22 9.579a.68.68 0 00-1.01 0 .81.81 0 000 1.086l2.892 3.11a.687.687 0 00.576.221.708.708 0 00.524-.338l4.219-6.803 3.449 2.648a.683.683 0 00.997-.178.806.806 0 00-.166-1.072l-4.05-3.11z"}})])
          )
        }
      }
    